/* Rotas usuario */
export const FIND_USER_BY_ID: string = '/api/user/findById/'
export const FIND_BY_USER_LOGIN: string = '/api/user/findByLogin/'
export const USER_VALIDATE: string = '/api/user/validatorUser/'
export const AUTH_USER: string = '/api/user/auth'
export const FIND_ALL_BY_PAGE_USER: string = '/api/user/page'
export const UPDATE_STATUS_USER: string = '/api/user/updateStatus/'
export const DELETE_PHOTO_BY_ID_USER = '/api/user/deletePhoto/'
export const CREATE_USER: string = '/api/user/create'
export const UPLOAD_PHOTO_USER: string = '/api/user/uploadPhoto/'
export const SOFT_DELETE_USER_BY_ID: string = '/api/user/softDeleteById/'
export const EDIT_USER: string = '/api/user/editar'
export const FIND_ALL_EXCLUDING_CURRENT_USER: string =
  '/api/user/findAllExcludingCurrentUser'

/* Rotas de Permission */
export const FIND_ALL_PERMISSION_USERS: string =
  '/api/permissaoUsuarios/findAllByIdUser/'
export const UPDATE_STATUS_PERMISSIONS_USER_BY_ID: string =
  '/api/permissaoUsuarios/updateStatus/'

/* Rotas produtos */
export const PRODUTO_FORM_BY_ID = '/api/produtos/form/'
export const REAJUSTE_PRECO_PRODUTO = '/api/produtos/reajuste'
export const FIND_ALL_RESUMO_PRODUTO = '/api/produtos/findAllResumoDto'
export const FIND_ALL_RESUMO_PRODUTO_COM_SALDO =
  '/api/produtos/findAllResumoDtoComSaldo'
export const FIND_ALL_RESUMO_PRODUTO_BY_FORNECEDOR =
  '/api/produtos/findAllResumoByIdFornecedorDto/'
export const PRODUCT_PRICE_ADJUSTMENT = '/api/produtos/reajuste'
export const GET_PRODUTO_EDIT_BY_ID = '/api/produtos/getProdutoForEditById/'
export const PRODUTO_FIND_BY_ID = '/api/produtos/findById/'
export const PRODUTOS_PAGINATION = '/api/produtos/page'
export const CREATE_PRODUTOS = '/api/produtos'
export const RELATORIO_PRODUTOS = '/api/produtos/relatorio?'
export const UPDATE_REGISTRO_PRODUTOS = '/api/produtos'
export const DELETE_PRODUTOS_BY_ID: string = '/api/produtos/'
export const UPDATE_STATUS_PRODUTOS = '/api/produtos/updateStatusById/'

/* Rotas fornecedores */
export const FIND_ALL_BY_PAGE_FORNECEDOR = '/api/fornecedores/page'
export const UPDATE_STATUS_FORNECEDOR = '/api/fornecedores/status/'
export const FIND_ALL_FORNECEDOR_BY_ID_SHOW = '/api/fornecedores/show'
export const CREATE_FORNECEDOR = '/api/fornecedores'
export const FIND_ALL_FORNECEDOR = '/api/fornecedores/findAll'
export const FIND_ALL_NAME_FORNECEDOR = '/api/fornecedores/findAllName'
export const DELETE_FORNECEDOR_BY_ID = '/api/fornecedores/'
export const GENERATE_RELATORIO_FORNECEDOR = '/api/fornecedores/relatorio'
export const FIND_BY_ID_FORNECEDOR = '/api/fornecedores/findById/'
export const UPDATE_REGISTRO_FORNECEDOR = '/api/fornecedores'

/*Rotas catalogos */
export const FIND_STEPPER_CATALOGO_BY_ID = '/api/catalogo/stepper/'
export const UPLOAD_FOTO_CAPA_CATALOGO: string = '/api/catalogo/upload/'
export const DELETE_FOTO_CAPA_CATALOGO_BY_ID = '/api/catalogo/deletePhoto/'
export const UPDATE_STEPPER_CATALOGO_BY_ID = '/api/catalogo/updateStepper/'
export const FIND_ALL_BY_PAGE_CATALOGO = '/api/catalogo/page'
export const CREATE_CATALOGO = '/api/catalogo'
export const UPDATE_CATALOGO = '/api/catalogo/update'
export const FIND_BY_ID_CATALOGO = '/api/catalogo/findById/'
export const DELETE_CATALOGO_BY_ID = '/api/catalogo/deleteById/'
export const UPDATE_STATUS_CATALOGO = '/api/catalogo/updateStatus/'

/* Rotas documentos do catalogo */

export const UPLOAD_CATALOGO_DOCUMENTOS: string =
  '/api/catalogoDocumentos/upload/'
export const DELETE_CATALOGO_DOCUMENTOS_BY_ID: string =
  '/api/catalogoDocumentos/deleteById/'
export const FIND_ALL_DOCUMENTOS_BY_ID_CATALOGO: string =
  '/api/catalogoDocumentos/findAllByIdCatalogo/'

/* Rotas produtos do catalogo */

export const FIND_ALL_BY_PAGE_CATALOGO_PRODUTOS =
  '/api/relCatalogoProdutos/page'
export const DELETE_PRODUTO_CATALOGO_BY_ID = '/api/relCatalogoProdutos/delete/'
export const SAVE_PRODUTO_CATALOGO = '/api/relCatalogoProdutos/save/'

/* Rotas caixa */
export const PAGE_CAIXA = '/api/caixa/page'
export const CAIXA_FIND_BY_ID = '/api/caixa/findById/'
export const ABERTURA_CAIXA = '/api/caixa/'

/* Rotas caixa movimento */
export const PAGE_CAIXA_MOVIMENTO = '/api/caixaMovimento/page'
export const CAIXA_MOVIMENTACAO = '/api/caixaMovimento/tipo/'
export const CAIXA_MOVIMENTACAO_DELETE_BY_ID = '/api/caixaMovimento/'

/* Rotas Grupo linha */
export const FIND_ALL_GRUPO = '/api/grupoLinha/findAllGrupo'
export const FIND_ALL_GRUPO_LINHA = '/api/grupoLinha/findAll'
export const PAGE_GRUPO_LINHA = '/api/grupoLinha/page'
export const FIND_ALL_LINHA = '/api/grupoLinha/findAllLinhas'
export const FIND_BY_ID_GRUPO_LINHA = '/api/grupoLinha/findById/'
export const CREATE_GRUPO_LINHA = '/api/grupoLinha'
export const EDIT_GRUPO_LINHA = '/api/grupoLinha'

/* Rotas operacional */
export const FIND_FIRST_OPERACIONAL: string = '/api/operacional/findFirst'
export const EDIT_OPERACIONAL: string = '/api/operacional/edit'

/* Rotas Marcas */
export const FIND_ALL_MARCA = '/api/marcas/findAll'
export const PAGE_MARCA = '/api/marcas/page'
export const CREATE_MARCA = '/api/marcas'
export const EDIT_MARCA = '/api/marcas'
export const FIND_MARCA_BY_ID = '/api/marcas/findById/'

/* Rotas clientes */
export const FIND_ALL_BY_PAGE_CLIENTES = '/api/clientes/page'
export const FIND_ALL_CLIENTE_BY_ID_SHOW = '/api/clientes/show'
export const UPDATE_STATUS_CLIENTES = '/api/clientes/status/'
export const CREATE_CLIENTES = '/api/clientes'
export const FIND_ALL_CLIENTES = '/api/clientes/all'
export const DELETE_CLIENTES_BY_ID = '/api/clientes/'
export const GENERATE_RELATORIO_CLIENTES = '/api/clientes/relatorio'
export const FIND_BY_ID_CLIENTES = '/api/clientes/findById/'
export const UPDATE_REGISTRO_CLIENTES = '/api/clientes/'

/* Rotas documentos */
export const VIEW_DOCUMENTOS: string = '/api/documentos/view/'
export const UPLOAD_DOCUMENTOS_TEMP: string = '/api/documentos/upload'
export const GET_IMAGE: string = '/api/documentos/image'
export const DOWNLOAD_DOCUMENTOS_BY_ID: string = '/api/documentos/download/'
export const DELETE_DOCUMENTOS: string = '/api/documentos/deleteById/'

/*Rotas rel documentos contas */

/*Rotas rel documentos pagar */
export const DOWNLOAD_DOCUMENTOS_PAGAR: string =
  '/api/relDocumentosContasPagar/download/'
export const UPLOAD_DOCUMENTOS_PAGAR: string =
  '/api/relDocumentosContasPagar/upload/'
export const FIND_ALL_DOCUMENTOS_PAGAR: string =
  '/api/relDocumentosContasPagar/all/'
export const DELETE_DOCUMENTOS_CONTAS_PAGAR_BY_ID_DOCUMENTO: string =
  '/api/relDocumentosContasPagar/deleteById/'

/*Rotas rel documentos receber */
export const DOWNLOAD_DOCUMENTOS_RECEBER: string =
  '/api/relDocumentosContas/download/'
export const UPLOAD_DOCUMENTOS_RECEBER: string =
  '/api/relDocumentosContas/upload/'
export const FIND_ALL_DOCUMENTOS_RECEBER: string =
  '/api/relDocumentosContas/all/'
export const DELETE_DOCUMENTOS_CONTAS_BY_ID_DOCUMENTO: string =
  '/api/relDocumentosContas/deleteById/'

/* Rotas Pagamentos a receber */
export const CREATE_PAGAMENTOS_RECEBER = '/api/pagamentosReceber'
export const FIND_ALL_BY_PAGE_PAGAMENTOS_RECEBER = '/api/pagamentosReceber/page'
export const DELETE_PAGAMENTOS_RECEBER_BY_ID = '/api/pagamentosReceber/'

/* Rotas Pagamentos a receber */
export const CREATE_PAGAMENTOS_PAGAR = '/api/pagamentosPagar'
export const FIND_ALL_BY_PAGE_PAGAMENTOS_PAGAR = '/api/pagamentosPagar/page'
export const DELETE_PAGAMENTOS_PAGAR_BY_ID = '/api/pagamentosPagar/'

/*Rotas contas PAGAR */
export const UPDATE_STATUS_CONTAS_PAGAR = '/api/contasPagar/updateStatus/'
export const FIND_ALL_BY_PAGE_CONTAS_PAGAR = '/api/contasPagar/page'
export const DELETE_CONTAS_PAGAR_BY_ID = '/api/contasPagar/'
export const CREATE_CONTAS_PAGAR = '/api/contasPagar'
export const FIND_ALL_CONTAS_PAGAR_BY_FORNECEDOR = '/api/contasPagar/print/'
export const FIND_STEPPER_CONTAS_PAGAR_BY_ID = '/api/contasPagar/stepper/'
export const FIND_CONTAS_PAGAR_BY_ID_AND_CONVERT_DTO = '/api/contasPagar/'
export const CONTAS_PAGAR_EDIT = '/api/contasPagar'
export const RESUME_TOTAIS_CONTAS_PAGAR_BY_ID_FORNECEDOR =
  '/api/contasPagar/findAllTotalResumeById/'

/*Rotas contas receber */
export const PRINT_CONTAS_RECEBER_BY_ID =
  '/api/contasReceber/printContasReceberAndPagamentos/'
export const FIND_ALL_BY_PAGE_CONTAS_RECEBER = '/api/contasReceber/page'
export const FIND_ALL_CONTAS_RECEBER_BY_CLIENTE = '/api/contasReceber/print/'
export const DELETE_CONTAS_RECEBER_BY_ID = '/api/contasReceber/'
export const UPDATE_STATUS_CONTAS_RECEBER_BY_ID =
  '/api/contasReceber/updateStatus/'
export const CREATE_CONTAS_RECEBER = '/api/contasReceber'
export const FIND_STEPPER_CONTAS_RECEBER_BY_ID = '/api/contasReceber/stepper/'
export const FIND_CONTAS_RECEBER_BY_ID_AND_CONVERT_DTO = '/api/contasReceber/'
export const CONTAS_RECEBER_EDIT = '/api/contasReceber'
export const RESUME_TOTAIS_CONTAS_RECEBER_BY_ID_CLIENTE =
  '/api/contasReceber/findAllTotalResumeById/'

/*Rotas vendas */
export const FIND_ALL_BY_PAGE_VENDAS = '/api/vendas/page'
export const CREATE_VENDAS = '/api/vendas'
export const EDIT_VENDAS = '/api/vendas'
export const SHOW_VENDA = '/api/vendas/show/'
export const PRINT_VENDAS_BY_ID = '/api/vendas/print/'
export const CANCELAR_OR_CANCEL_VENDAS_BY_ID = '/api/vendas/cancelarOrDelete/'
export const FINALIZAR_VENDA = '/api/vendas/finalizar/'
export const FIND_BY_ID_CONVERT_DTO_VENDAS = '/api/vendas/findByIdConvertDto/'
export const FIND_STEPPER_VENDAS_BY_ID = '/api/vendas/stepper/'
export const UPDATE_STEPPER_VENDAS: string = '/api/vendas/updateStepper/'

/*Rotas orcamentos */
export const FIND_ALL_BY_PAGE_ORCAMENTOS = '/api/orcamentos/page'
export const EXPORT_ORCAMENTOS_TO_VENDA = '/api/orcamentos/export/'
export const CREATE_ORCAMENTOS = '/api/orcamentos'
export const EDIT_ORCAMENTOS = '/api/orcamentos'
export const SHOW_ORCAMENTOS = '/api/orcamentos/show/'
export const PRINT_ORCAMENTOS_BY_ID = '/api/orcamentos/print/'
export const CANCELAR_OR_CANCEL_ORCAMENTOS_BY_ID =
  '/api/orcamentos/cancelarOrDelete/'
export const FINALIZAR_ORCAMENTOS = '/api/orcamentos/finalizar/'
export const FIND_BY_ID_CONVERT_DTO_ORCAMENTOS =
  '/api/orcamentos/findByIdConvertDto/'
export const FIND_STEPPER_ORCAMENTOS_BY_ID = '/api/orcamentos/stepper/'
export const UPDATE_STEPPER_ORCAMENTOS: string =
  '/api/orcamentos/updateStepper/'

/*Rotas categorias contas */
export const FIND_ALL_CATEGORIA_CONTAS = '/api/categoriaContas/findAll'

/*Produtos orcamentos */
export const FIND_ALL_PRODUTOS_ORCAMENTOS_BY_PAGE =
  '/api/produtosOrcamentos/page/'
export const SAVE_PRODUTOS_ORCAMENTOS = '/api/produtosOrcamentos/'
export const GET_PRODUTOS_ORCAMENTOS_BY_ID = '/api/produtosOrcamentos/'
export const DELETE_PRODUTOS_ORCAMENTOS_BY_ID = '/api/produtosOrcamentos/'

/*Produtos vendas */
export const FIND_ALL_PRODUTOS_VENDAS_BY_PAGE = '/api/produtosVendas/page/'
export const SAVE_PRODUTOS_VENDAS = '/api/produtosVendas/'
export const GET_PRODUTOS_VENDAS_BY_ID = '/api/produtosVendas/'
export const DELETE_PRODUTOS_VENDAS_BY_ID = '/api/produtosVendas/'

/*Produtos dashboard */
export const DASHBOARD_FIND_ALL_SERVICES = '/api/dashboard/'

/*Rotas compras */
export const CREATE_COMPRAS = '/api/compras'
export const CANCEL_OR_DELETE_COMPRAS = '/api/compras/cancelarOrDelete/'
export const SHOW_COMPRA = '/api/compras/show/'
export const UPDATE_COMPRAS = '/api/compras'
export const PRINT_COMPRAS_BY_ID = '/api/compras/print/'
export const FINALIZAR_COMPRAS = '/api/compras/finalizarCompra/'
export const FIND_BY_ID_CONVERT_DTO_COMPRAS = '/api/compras/findByIdConvertDto/'
export const FIND_ALL_BY_PAGE_COMPRAS = '/api/compras/page'
export const FIND_STEPPER_COMPRAS_BY_ID = '/api/compras/stepper/'
export const UPDATE_STEPPER_COMPRAS: string = '/api/compras/updateStepper/'

/*Rotas rel documentos compras */
export const UPLOAD_DOCUMENTOS_COMPRAS: string =
  '/api/relDocumentosCompras/upload/'
export const FIND_ALL_DOCUMENTOS_COMPRAS: string =
  '/api/relDocumentosCompras/all/'
export const DELETE_DOCUMENTOS_COMPRAS_BY_ID_DOCUMENTO: string =
  '/api/relDocumentosCompras/deleteById/'

/* Produtos compra */
export const FIND_ALL_PRODUTOS_COMPRAS_BY_PAGE = '/api/produtosCompras/page/'
export const SAVE_PRODUTOS_COMPRAS = '/api/produtosCompras/'
export const DELETE_PRODUTOS_COMPRAS = '/api/produtosCompras/'
export const FIND_HISTORICO_PRODUTO_BY_ID =
  '/api/produtosCompras/pageHistoricoProduto'

/* Relatórios */
export const REPORTS_ABC = '/api/reports/abc'
export const REPORTS_DRE = '/api/reports/dre'
export const REPORTS_RFM = '/api/reports/rfm'
export const REPORTS_ABC_CLIENTE = '/api/reports/abcCliente'
export const REPORTS_CAIXA_PREVISTO_REALIZADO =
  '/api/reports/caixaPrevistoRealizado'
export const REPORTS_VENDAS_BY_PERIODO = '/api/reports/vendas'
export const REPORTS_COMPRAS_BY_PERIODO = '/api/reports/compras'
export const REPORTS_CONTAS_PAGAR = '/api/reports/contasPagar'
export const REPORTS_CONTAS_RECEBER = '/api/reports/contasReceber'

/* Rotas eventos */
export const FIND_ALL_EVENTOS_BY_ID_USUARIOS = '/api/eventos/findAllByUser'
export const PRINT_EVENTOS = '/api/eventos/print'
export const FIND_ALL_USUARIO_BY_ID_AND_DATA =
  '/api/eventos/findAllByUserAndData'
export const SAVE_EVENTOS: string = '/api/eventos'
export const DELETE_BY_EVENTOS: string = '/api/eventos/deleteById/'
export const FIND_BY_ID_EVENTO: string = '/api/eventos/findById/'
export const EDIT_EVENTO: string = '/api/eventos/edit'
